<!--
 * @Desc: 菜单
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-09 09:17:26
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-menu">
        <div class="logo-hold">
            <div class="container">
                <img src="../../../public/statics/images/Menu/logo.png" />
                <div>
                    <el-input
                        size="mini"
                        v-model="searchText"
                        placeholder="请输入关键词"
                        @keyup.enter.native="searchHandle"
                    >
                        <i
                            slot="suffix"
                            @click="searchHandle"
                            class="el-input__icon el-icon-search"
                        ></i>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="menu-hold">
            <div class="container">
                <ul class="nav">
                    <li
                        class="nav-item"
                        v-for="(item,idx) in menuList"
                        :key="idx"
                        @click="navClick(item)"
                        :class="[active == item.id ? 'on' : '']"
                    >
                        {{ item.name }}
                    </li>
                </ul>
                <div class="calendar">
                    {{ nowDate }} {{ nowWeek }}
                    {{
                        nongli != -1
                            ? "农历 " + (nongli.IMonthCn + nongli.IDayCn)
                            : ""
                    }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import calendarFormatter from "@/api/dateChange";
import { Message } from "element-ui";
export default {
    data() {
        return {
            timer: "",
            nowDate: "", // 当前日期
            nowTime: "", // 当前时间
            nowWeek: "", // 当前星期
            nongli: "", // 农历日期
            searchText: "", // 搜索文字
            menuList:[],//菜单列表
        };
    },
    props: {
        // 菜单选中，
        active: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {
        let that = this;
        // 定时刷新时间 需要显示时间时
        // this.timer = setInterval(() => {
        //     that.dealWithTime(new Date()); // 修改数据date
        // }, 500);

        if (that.Cookies.get("menuList")){
            that.menuList = JSON.parse(that.Cookies.get("menuList"))
            // 农历日期获取
            let current_time = new Date(JSON.parse(that.Cookies.get("webTime")))
            let year = current_time.getFullYear();
            let month = current_time.getMonth() + 1;
            let day = current_time.getDate();
            this.nongli = calendarFormatter.solar2lunar(year, month, day);

            // 时间实时更新
            this.dealWithTime(current_time);
        } else {
            let timerMenu = setInterval(function(){
                that.menuList = JSON.parse(that.Cookies.get("menuList"))
                // 农历日期获取
                let current_time = new Date(JSON.parse(that.Cookies.get("webTime")))
                let year = current_time.getFullYear();
                let month = current_time.getMonth() + 1;
                let day = current_time.getDate();
                this.nongli = calendarFormatter.solar2lunar(year, month, day);

                // 时间实时更新
                this.dealWithTime(current_time);
                if (that.Cookies.get("menuList")) {
                    clearInterval(timerMenu)
                }
            },1000)
        }
    },
    methods: {
        /**
         * @name: 获取当前时间
         * @param {*} data
         * @return {*}
         * @desc: 获取当前时间
         */
        dealWithTime(data) {
            // 获取当前时间
            let formatDateTime;
            let Y = data.getFullYear();
            let M = data.getMonth() + 1;
            M = M < 10 ? "0" + M : M;
            let D = data.getDate();
            D = D < 10 ? "0" + D : D;
            let H = data.getHours();
            let Min = data.getMinutes();
            let S = data.getSeconds();
            let W = data.getDay();
            H = H < 10 ? "0" + H : H;
            Min = Min < 10 ? "0" + Min : Min;
            S = S < 10 ? "0" + S : S;
            switch (W) {
                case 0:
                    W = "日";
                    break;
                case 1:
                    W = "一";
                    break;
                case 2:
                    W = "二";
                    break;
                case 3:
                    W = "三";
                    break;
                case 4:
                    W = "四";
                    break;
                case 5:
                    W = "五";
                    break;
                case 6:
                    W = "六";
                    break;
                default:
                    break;
            }
            this.nowDate = Y + "-" + M + "-" + D + "";
            this.nowWeek = "星期" + W;
            this.nowTime = H + ":" + Min + ":" + S;
            // formatDateTime = Y + "年" + M + "月" + D + "日 " + " 周" +W + H + ":" + Min + ":" + S;
        },
        /**
         * @name: 搜索
         * @return {*}
         * @desc: 搜索
         */
        searchHandle() {
            if(!this.searchText) {
                Message({
                    message: "关键词 必须填写",
                    type: "error",
                    customClass: "mobileClass",
                });
                return
            }
            this.$toPath('/Search', {key:this.searchText,active:-1});
        },
        /**
         * @name: 菜单点击
         * @return {*}
         * @desc: 菜单点击
         */
        navClick(item) {
            this.$toPath(item.url, {
                active:item.id
            });
        },
    },
};
</script>

<style scoped>
.page-menu {
    position: sticky;
    z-index: 1000;
    top: 0;
    min-width: 1200px;
    width: 100%;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.6);
}
.page-menu .logo-hold {
    background: #fff;
}
.page-menu .logo-hold .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 68px;
}
.page-menu .logo-hold /deep/ .el-input--mini .el-input__inner {
    height: 30px;
    line-height: 30px;
}
.page-menu .logo-hold /deep/ .el-input__inner {
    border-radius: 15px;
}
.page-menu .menu-hold {
    background: #002140;
}
.page-menu .menu-hold .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
}
.page-menu .menu-hold .container .nav {
    display: flex;
}
.page-menu .menu-hold .container .nav .nav-item {
    cursor: pointer;
    line-height: 44px;
    margin-right: 28px;
    position: relative;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
}
.page-menu .menu-hold .container .nav .nav-item::after {
    position: absolute;
    content: "";
    transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    transform: scaleX(0);
    transform-origin: right;
    background-color: #fff;
    right: 0px;
    bottom: 0px;
    left: 0px;
    height: 2px;
}
.page-menu .menu-hold .container .nav .nav-item:hover::after {
    transform: scaleX(1);
    transform-origin: left;
}
.page-menu .menu-hold .container .nav .nav-item.on::after {
    transform: scaleX(1);
}
.page-menu .menu-hold .container .calendar {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #dfe3ee;
}
</style>
